module.exports = __webpack_public_path__ + "media/crypto/dai-c901ac08.png";